import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const ChatMessageStyled = styled.div`
  display: flex;
  margin-bottom: 24px;
  background-color: ${COLORS.black};
`;

export default ChatMessageStyled;
